import { useInfiniteQuery } from 'react-query';

import { PartnersFeedResponse, fetchPartnersFeed } from '@utils/backend-api/partners';

export const PARTNERS_FEED_KEY = 'PARTNERS_FEED';

export default function usePartnersFeed() {
  const {
    data: partnersFeed,
    fetchNextPage: fetchNextPartnersFeedPage,
    hasNextPage: hasNextPartnersFeedPage,
    isFetching: isFetchingPartnersFeed,
    isLoading: isLoadingPartnersFeed,
  } = useInfiniteQuery<PartnersFeedResponse>({
    keepPreviousData: true,
    queryKey: [PARTNERS_FEED_KEY],
    staleTime: Infinity,
    queryFn: ({ pageParam = 1 }) =>
      fetchPartnersFeed({
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });

  return {
    fetchNextPartnersFeedPage,
    hasNextPartnersFeedPage,
    isFetchingPartnersFeed,
    isLoadingPartnersFeed,
    partnersFeed,
  };
}
